<template>
    <section>
        <div class="filter-result background-white box-shadow-small border-radius">
            <div>
                <empty-tip :show="!lists.length"></empty-tip>
                <div class="table-list mt-20 mb-20">
                    <el-table v-if="lists.length"
                              :data="lists">
                        <el-table-column
                                prop="projectName"
                                label="项目名称"
                                :show-overflow-tooltip="true"
                                align="center">
                        </el-table-column>
                        <el-table-column
                                prop="createTime"
                                label="创建时间"
                                :show-overflow-tooltip="true"
                                align="center">
                        </el-table-column>
                        <el-table-column
                                prop="resumeCount"
                                label="接收简历"
                                :show-overflow-tooltip="true"
                                align="center">
                        </el-table-column>
                        <el-table-column
                                label="面试官查看"
                                :show-overflow-tooltip="true"
                                align="center">
                            <template slot-scope="scope">
                                <i v-if="scope.row.interviewerCanUse" class="el-icon-circle-check color-success"></i>
                                <i v-else class="el-icon-circle-close color-danger"></i>
                            </template>
                        </el-table-column>

                        <el-table-column
                                label="操作"
                                :show-overflow-tooltip="true"
                                align="center">
                            <template slot-scope="scope">
                                <el-button size="small" v-if="scope.row.interviewerCanUse"
                                           @click="toggleOpen(false, scope.row)" type="danger">关闭
                                </el-button>
                                <el-button size="small" v-else @click="toggleOpen(true, scope.row)" type="success">开放
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <el-dialog size="small" title="权限配置" :visible.sync="showDialog">
            <div>
                <p v-if="!isOpen">确定要向面试官开放该项目的权限吗？权限开放后面试官将会看到该项目相关的面试记录</p>
                <p v-else>确定要向面试官关闭该项目的权限吗？权限开放后面试官将会看不到该项目相关的面试记录</p>
            </div>
            <div slot="footer">
                <el-button @click="permissionChange()" type="primary">确定</el-button>
                <el-button @click="showDialog = false">取消</el-button>
            </div>
        </el-dialog>
    </section>
</template>

<script>
    import QueryListExtend from 'components/queryListExtend'
    import EmptyTip from 'views/common/empty'

    export default {
        // extends: QueryListExtend,
        name: 'projectPermission',
        components: {EmptyTip},
        data: function () {
            return {
                fetchUrl: 'http://frontend163.com:7300/mock/5badca8a1d71b43fc281d79d/wb/permission/project/list.api',
                lists: [],
                showDialog: false,
                isOpen: false,
                item: null
            }
        },
        methods: {
            permissionChange () {
                this.$axios.post('http://frontend163.com:7300/mock/5badca8a1d71b43fc281d79d/wb/permission/project/update.api', {
                    isOpen: this.isOpen,
                    id: this.item.id
                }, {'X-showMessage': true}).then(({result}) => {
                    this.showDialog = false
                }).catch(console.error)
            },
            toggleOpen (isOpen, item) {
                this.isOpen = isOpen
                this.showDialog = true
                this.item = item
            },
            fetchData () {
                this.$axios.get(this.fetchUrl).then(({result}) => {
                    console.log(444, result)
                    this.lists = result.list
                }).catch(console.error)
            }
        },
        created () {
            this.fetchData()
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// projectList.vue?385bfefe